// Shared context for the WE Alignment Index assessment.
import { createContext, useContext } from 'react';

export const AssessmentContext = createContext(null);

export function useAssessmentCtx() {
  const ctx = useContext(AssessmentContext);
  if (!ctx) {
    throw new Error('useAssessmentCtx must be used inside <AssessmentContext.Provider>');
  }
  return ctx;
}
